import React, { useEffect, useState } from 'react';
import FirmModal from './FirmModal';
import { createFirm } from '../../requests/firms';
import './FirmList.scss';

const emptyFirmForm = {
    NAME: '',
    ADDRESS: '',
    CITY: '',
    STATE: '',
    ZIP: '',
    PHONE: '',
    WEBSITE: '',
};

/**
 * The "+" popup on /firms with its save: a firm already on file at the same
 * address is refused once, and "Add Anyway" adds it as another location.
 * Also opened from the Firm box on the vendor and agent pages.
 */
export default function AddFirmModal({ show, initialName = '', onClose, onCreated }) {
    const [step, setStep] = useState('form');
    const [form, setForm] = useState(emptyFirmForm);
    const [saveError, setSaveError] = useState(null);
    const [saveBusy, setSaveBusy] = useState(false);
    const [duplicateMessage, setDuplicateMessage] = useState(null);

    useEffect(() => {
        if (!show) return;
        setStep('form');
        setForm({ ...emptyFirmForm, NAME: initialName });
        setSaveError(null);
        setSaveBusy(false);
    }, [show]);

    const save = (force) => {
        if (saveBusy) return;

        const payload = {};
        Object.keys(emptyFirmForm).forEach((k) => {
            const v = (form[k] || '').trim();
            if (v) payload[k] = v;
        });

        if (!payload.NAME) {
            setSaveError('Firm name is required');
            return;
        }

        setSaveBusy(true);
        setSaveError(null);

        createFirm(payload, { force })
            .then((firm) => {
                setSaveBusy(false);
                onCreated(firm);
            })
            .catch((err) => {
                setSaveBusy(false);
                if (err && err.status === 409) {
                    setStep('confirm');
                    setDuplicateMessage(err.message || null);
                    return;
                }
                setSaveError(err && err.message ? err.message : 'Failed to save firm');
            });
    };

    return (
        <FirmModal
            show={show}
            onClose={onClose}
            step={step}
            form={form}
            onFormChange={(field, value) => setForm((prev) => ({ ...prev, [field]: value }))}
            onSubmit={(e) => {
                e.preventDefault();
                // On a record page this form sits inside the page's own form.
                e.stopPropagation();
                save(false);
            }}
            saveError={saveError}
            saveBusy={saveBusy}
            duplicateMessage={duplicateMessage}
            onBackToForm={() => {
                setStep('form');
                setSaveError(null);
            }}
            onAddAnyway={() => save(true)}
        />
    );
}
